import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  position: relative;
  user-select: none;
`;

export const Content = styled.div`
  width: 200px;
  padding: 20px 5px;
`;

export const Header = styled.div`
  background-color: rgba(0, 0, 0, 0.52);
  box-shadow: inset 0 0 10px 5px rgba(0, 0, 0, 0.08);
  text-align: center;
  margin-bottom: 5px;
  position: absolute;
  top: -30px;
  left: 0;
  right: 0;
`;

export const Reset = styled.div`
  position: absolute;
  right: 3px;
  top: 3px;
`;

export const Image = styled.img`
  width: 200px;
  position: relative;
  top: 35px;
`;
